import { motion, Variants } from "framer-motion";

interface AnimatedCheckMarkProps {
    size?: number;
    duration?: number;
    delay?: number;
    strokeWidth?: number;
    color?: string;
    className?: string;
}

export const AnimatedCheckMark: React.FC<AnimatedCheckMarkProps> = ({
    size = 40,
    duration = 0.4,
    delay = 0,
    strokeWidth = 2,
    color = "currentColor",
    className = ""
}) => {
    const checkmarkPath = "M9 12l2 2 4-4";

    const checkmarkVariants: Variants = {
        hidden: {
            pathLength: 0,
            opacity: 0
        },
        visible: {
            pathLength: 1,
            opacity: 1,
            transition: {
                pathLength: {
                    duration: duration,
                    delay: delay,
                    ease: "easeInOut"
                },
                opacity: {
                    duration: 0.1,
                    delay: delay
                }
            }
        }
    };

    return (
        <div className={`inline-flex items-center justify-center ${className}`}>
            <motion.svg
                width={size}
                height={size}
                viewBox="0 0 24 24"
                fill="none"
                initial="hidden"
                animate="visible"
            >
                <motion.path
                    d={checkmarkPath}
                    stroke={color}
                    strokeWidth={strokeWidth}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    fill="none"
                    variants={checkmarkVariants}
                />
            </motion.svg>
        </div>
    );
};
